// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5bad92d6","498":"5bef6b71","513":"052aaa8a"}[chunkId] + ".chunk.js";
};